import { SignOut } from './SignOut';
import { Messages } from './Messages';
import { Menu } from './Menu';
import { topLevelNavigations } from './topLevelNavigations';
import { useCurrentUserEmsTeam } from './hooks/useCurrentUserEmsTeam';
import { Link } from 'react-router-dom';

/** ヘッダーのコンポーネント。 */
export const Header = () => {
  const { emsTeam, isLoading } = useCurrentUserEmsTeam();

  return (
    <div className="max-w-[1280px] m-auto px-[40px] py-[20px]">
      <div className="flex justify-between content-center">
        {isLoading ? (
          <p>Loading...</p>
        ) : (
          <>
            <Link to={'/jian-list'}>
              <p className="text-[18px] text-textPrimary noto-sans-jp-bold">
                {emsTeam?.emsTeamName ?? ''}
              </p>
            </Link>
          </>
        )}
        <div className="hidden xl:block">
          <DisplayPc />
        </div>
        <div className="block xl:hidden">
          <DisplayTablet />
        </div>
      </div>
    </div>
  );
};

const DisplayPc = () => {
  const { emsTeam } = useCurrentUserEmsTeam();
  
  return (
    <div className="flex gap-[24px]">
      {topLevelNavigations.map((navigation, index) => 
        navigation.isMessages ? (
          emsTeam?.accessLevel === "DEPARTMENT" ? (
            <Messages key={index} />
          ) : null
        ) : (
          <Link key={index} to={navigation.url}>
            <p className="text-[18px] text-textPrimary noto-sans-jp-bold">
              {navigation.displayName}
            </p>
          </Link>
        )
      )}
      <SignOut />
    </div>
  );
};

const DisplayTablet = () => {
  const { emsTeam } = useCurrentUserEmsTeam();
  
  return (
    <div className="flex gap-[24px]">
      {emsTeam?.accessLevel === "DEPARTMENT" && (
        <Messages />
      )}
      <SignOut />
      <Menu />
    </div>
  );
};
